import { debounce } from './debounce'
import { getAncestors } from './getAncestors'
import { getFormData } from './getFormData'
import { filterObjectValues } from './object/filterObjectValues'
import { getTheme, setTheme } from './theme'
import { toTitleCase } from './toTitleCase'
import { loginSchema } from './schemas/loginSchema'
import { redirectAfterSignIn, redirectToLogin } from './redirect'
import { setQueryParams } from './setQueryParams'
import { setResult, setSearchQueryParam } from './setSearchResult'
import { formatCurrency } from './formatCurrency'
import { toTierName } from './toTierName'
import { sortFacilities } from './sortFacilities'
import { getTierNamesByTierId, getTierNamesByTierLevel } from './getTierNames'
import { conditionalRequiredZodError } from './conditionalRequiredZodError'
import { formatAcceptLanguage } from './formatAcceptLanguage'
import { getTldFromUrl } from './getTldFromUrl'
import { getCityNamesByCityId } from './getCityNamesByCityId'
import { SENTRY_IGNORE_ERRORS } from './sentryIgnoreErrors'
import { balanceText } from './balanceText'
import { decision } from './ab-testing/decision'
import { getWeekByDate } from './date/getWeekByDate'
import { formatError } from './formatError'
import { getHourDifferenceFromUTC } from './date/getHourDifferenceFromUTC'

export const utils = {
  abTesting: {
    decision,
  },
  date: {
    getHourDifferenceFromUTC,
    getWeekByDate,
  },
  object: {
    filterObjectValues,
  },
  balanceText,
  conditionalRequiredZodError,
  debounce,
  formatAcceptLanguage,
  formatCurrency,
  formatError,
  getAncestors,
  getCityNamesByCityId,
  getFormData,
  getTierNamesByTierId,
  getTierNamesByTierLevel,
  getTldFromUrl,
  schemas: {
    loginSchema,
  },
  redirect: {
    toLogin: redirectToLogin,
    afterSignIn: redirectAfterSignIn,
  },
  SENTRY_IGNORE_ERRORS,
  setQueryParams,
  setResult,
  setSearchQueryParam,
  sortFacilities,
  theme: {
    get: getTheme,
    set: setTheme,
  },
  toTierName,
  toTitleCase,
}
